<template>
  <div class="relative">
    <Card v-if="!appointmentID">
      <CardBody>
        <div class="w-full flex gap-2">
          <Button
            :label="$t('ui.actions.new')"
            icon="plus"
            @click="$emit('new-appointment')"
          />
          <Button
            v-tippy="{
              content:
                selectedCallCenterCommsConfig?.emailAddress == null
                  ? 'Cannot send emails from your active call center'
                  : agreementData.customer.contact.email == null
                    ? 'No email address for this customer'
                    : ''
            }"
            :disabled="
              selectedCallCenterCommsConfig?.emailAddress == null || agreementData.customer.contact.email == null
            "
            label="Send Invite"
            icon="paper-plane"
            severity="secondary"
            outlined
            @click="$emit('send-invite')"
          />
        </div>
        <div
          v-if="appointmentsData"
          class="mt-5"
        >
          <AgreementAppointments :appointments-list="appointmentsData" />
        </div>
        <div
          v-else
          class="mt-5"
        >
          <Skeleton
            height="1rem"
            width="15rem"
            class="mb-2"
          />
          <Skeleton
            height="4rem"
            class="mb-2"
          />
          <Skeleton
            height="4rem"
            class="mb-4"
          />
          <Skeleton
            height="1rem"
            width="15rem"
            class="mb-2"
          />
          <Skeleton
            height="4rem"
            class="mb-2"
          />
          <Skeleton
            height="4rem"
            class="mb-2"
          />
        </div>
      </CardBody>
    </Card>
    <div v-if="appointmentID">
      <AgreementAppointment
        :agreement-data="agreementData"
        @appointment-updated="$emit('appointment-updated', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
// composables
import { computed } from 'vue'
// stores
import { useCallCenterStore } from '@/stores/CallCenterStore'
// components
import Card from '@/components/card/Card.vue'
import CardBody from '@/components/card/CardBody.vue'
import Button from '@/components/button/Button.vue'
import Skeleton from '@/components/skeleton/Skeleton.vue'
import AgreementAppointments from '@/components/unique/agreement/AgreementAppointments.vue'
import AgreementAppointment from '@/components/unique/agreement/AgreementAppointment.vue'
// types
import type { Agreement, DealershipCommsConfigItem } from '@/types/domain/agreement'
import type { AppointmentListItem } from '@/types/domain/appointment'

const callCenterStore = useCallCenterStore()

interface Props {
  agreementData: Agreement
  appointmentsData: AppointmentListItem[] | null
  appointmentID: string | number | null
}

const props = defineProps<Props>()

defineEmits<{
  'new-appointment': []
  'send-invite': []
  'appointment-updated': [data: AppointmentListItem]
}>()

/**
 * Computed selected call center comms config based on selected call center
 */
const selectedCallCenterCommsConfig = computed<DealershipCommsConfigItem | null>(() => {
  if (!props.agreementData || !callCenterStore.selectedCallCenter) {
    return null
  }
  return (
    props.agreementData.dealership.commsConfig.find(
      config => config.callCenterId.toString() === callCenterStore.selectedCallCenter
    ) || null
  )
})
</script>
